"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const jlDataUtils_1 = require("../../utils/jlDataUtils");
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
const CitrusAnalytics = ({ adId, type = "banner", campaignName, }) => {
    (0, react_1.useEffect)(() => {
        if (adId && campaignName && type) {
            const eventData = { adId, type, campaignName };
            (0, jlDataUtils_1.addCitrusBannerToJlData)(eventData);
            (0, dispatchAnalytics_1.dispatchCitrusAnalyticsEvent)(Object.assign({ action: "citrusAd.impression" }, eventData));
        }
        else {
            (0, jlDataUtils_1.clearCitrusBannersFromJlData)();
        }
        return () => (0, jlDataUtils_1.clearCitrusBannersFromJlData)();
    }, [adId, campaignName, type]);
    return null;
};
exports.default = CitrusAnalytics;
